/* template */
<template minapp="mpx" xlang="wxml"><contact-dialog :show="(show)" title="注册成功" confirmText="去登录" @confirm="confirmtDialog" class="register-dialog"><div slot="icon" class="inner-icon"><mpx-image :src="(icon)" class="inner-image"/></div><div class="inner-box"><div class="inner-text">账号：{{account}}</div><div class="inner-text">密码：{{password}}</div></div></contact-dialog></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m06d7bf44"}'>
  .inner-box
    background #F6F7F8
    padding 8px
    font-size 12px 
    line-height 16px
    color #666
    margin 12px 0
    border-radius 8px
    .inner-text
      margin-top 4px
      font-family PingFangSC-Medium;
      font-size 14px
      font-weight normal
      line-height 18px
      letter-spacing 0px
      color #333333
      &:first-child
        margin-top 0
  .inner-icon
    display flex
    justify-content center
    margin-bottom 5px
    .inner-image
      width 63px
      height 67px
  .register-dialog
    /deep/ .one-btn
      margin 0 16px 24px 16px
      align-items center
    /deep/ .contact-dialog-confirm
      background #1473FF
      margin-left 0
      color #FFFFFF
      font-family PingFangSC-Medium
      font-size 16px
      font-weight normal
      line-height 19px
      text-align center
      padding-top 13px !important
      padding-bottom 16px !important
      box-sizing content-box

</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m06d7bf44"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./success-dialog.mpx.js?isComponent&outputPath=components%2Fsuccess-dialog06d7bf44%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./success-dialog.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fsuccess-dialog06d7bf44%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m06d7bf44"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/success-dialog06d7bf44/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'contact-dialog':getComponent(require("../../../contact/components/contact-dialog/index.mpx?isComponent&outputPath=components%2Findexd3416d8a%2Findex")),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
